"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreImage = _interopRequireDefault(require("@legacy-vfuk/core-image"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var Styled = _interopRequireWildcard(require("./styles/ImageContainer.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ImageContainer = function ImageContainer(_ref) {
  var contentAlignment = _ref.contentAlignment,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      primaryImage = _ref.primaryImage,
      secondaryImage = _ref.secondaryImage,
      contentSize = _ref.contentSize,
      imageHeight = _ref.imageHeight,
      dataSelectorPrefix = _ref.dataSelectorPrefix;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      backgroundImageWidth = _useState2[0],
      setBackgroundImageWidth = _useState2[1];

  var imageWrapper = (0, _react.useRef)(null);

  var handleResize = function handleResize() {
    if (imageWrapper.current) setBackgroundImageWidth(imageWrapper.current.clientWidth);
  };

  (0, _react.useEffect)(function () {
    handleResize();
    window.addEventListener('resize', handleResize, false);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [imageWrapper, setBackgroundImageWidth]);

  var setImageProps = function setImageProps() {
    var _backgroundImage$sm, _backgroundImage$md, _backgroundImage$lg, _backgroundImage$xl;

    if (!backgroundImage) return undefined;
    var position = 'center';
    if (contentAlignment === 'left') position = 'top left';
    if (contentAlignment === 'right') position = 'top right';
    return {
      sm: {
        size: 'initial',
        position: 'center',
        src: (_backgroundImage$sm = backgroundImage.sm) === null || _backgroundImage$sm === void 0 ? void 0 : _backgroundImage$sm.src,
        repeat: 'no-repeat'
      },
      md: {
        size: 'initial',
        position: 'center',
        src: (_backgroundImage$md = backgroundImage.md) === null || _backgroundImage$md === void 0 ? void 0 : _backgroundImage$md.src,
        repeat: 'no-repeat'
      },
      lg: {
        size: 'initial',
        position: position,
        src: (_backgroundImage$lg = backgroundImage.lg) === null || _backgroundImage$lg === void 0 ? void 0 : _backgroundImage$lg.src,
        repeat: 'no-repeat'
      },
      xl: {
        size: 'initial',
        position: position,
        src: (_backgroundImage$xl = backgroundImage.xl) === null || _backgroundImage$xl === void 0 ? void 0 : _backgroundImage$xl.src,
        repeat: 'no-repeat'
      }
    };
  };

  return /*#__PURE__*/_react["default"].createElement(Styled.BackgroundWrapper, {
    contentAlignment: contentAlignment,
    contentSize: contentSize,
    imageHeight: imageHeight,
    ref: imageWrapper
  }, /*#__PURE__*/_react["default"].createElement(Styled.BackgroundImage, {
    backgroundColor: backgroundColor,
    backgroundImage: setImageProps(),
    contentAlignment: contentAlignment,
    backgroundImageWidth: backgroundImageWidth,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'background-image')
  }), /*#__PURE__*/_react["default"].createElement(Styled.ImageWrapper, null, primaryImage && /*#__PURE__*/_react["default"].createElement(Styled.PrimaryImageWrapper, {
    primaryVerticalAlign: primaryImage.verticalAlign
  }, /*#__PURE__*/_react["default"].createElement(_coreImage["default"], {
    sm: {
      src: primaryImage.src,
      width: '300px'
    },
    alt: primaryImage.alt,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'primary-image')
  })), secondaryImage && /*#__PURE__*/_react["default"].createElement(Styled.SecondaryImageWrapper, {
    horizontalAlign: secondaryImage.horizontalAlign,
    secondaryVerticalAlign: secondaryImage.verticalAlign
  }, /*#__PURE__*/_react["default"].createElement(_coreImage["default"], {
    sm: {
      src: secondaryImage.src,
      width: '200px'
    },
    alt: secondaryImage.alt,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'secondary-image')
  }))));
};

ImageContainer.displayName = "ImageContainer";
var _default = ImageContainer;
exports["default"] = _default;
//# sourceMappingURL=ImageContainer.js.map